import React from "react";

const About = () => {
  return (
    <section style={styles.section}>
      <div style={styles.container}>
        {/* TEXT CONTENT */}
        <div style={styles.contentSide}>
          <div style={styles.badge}>ABOUT US</div>
          <h2 style={styles.heading}>My Story</h2>
          <div style={styles.accentLine}></div>

          <div style={styles.textBlock}>
            <p style={styles.paragraph}>
              I'm <span style={styles.highlight}>Gaurav Tiwari</span>, an Indian
              engineer who got into crypto out of curiosity—and stayed through
              its toughest lessons.
            </p>

            <p style={styles.paragraph}>
              Back in 2015, I had a secure, high-paying job, but something felt
              missing. That's when crypto caught my attention—a space full of
              opportunity, yet full of risk.
            </p>

            <p style={styles.paragraph}>
              Like many people starting out, I made mistakes. I trusted the
              wrong people, faced frauds, and lost money. There were moments of
              doubt—but I chose not to quit.
            </p>

            <p style={styles.paragraph}>
              Instead, I went deeper. I studied the market, understood the
              risks, and slowly turned my losses into learning—and learning into
              profits.
            </p>

            <p style={styles.paragraph}>
              In 2020, I took a bold step and left my job to go all in. That
              decision changed my life.
            </p>

            <p style={styles.paragraph}>
              Today, I work with clients across the world—from beginners to
              business owners and even celebrities helping them grow, protect,
              and manage their crypto investments.
            </p>

            <p style={styles.paragraph}>
              Because for me, crypto isn't just about profits—it's about making
              the right decisions and helping others win with you.
            </p>
          </div>
        </div>

        {/* IMAGE SIDE */}
        <div style={styles.imageSide}>
          <div style={styles.imageWrapper}>
            <img
              src="/about.jpeg"
              alt="Our Story"
              style={styles.image}
              // Fallback if image doesn't exist yet
              onError={(e) => {
                e.target.src =
                  "https://images.unsplash.com/photo-1639762681485-074b7f938ba0?auto=format&fit=crop&q=80&w=800";
              }}
            />
            {/* Decorative element */}
            <div style={styles.imageDecor}></div>
          </div>
        </div>
      </div>
    </section>
  );
};

const styles = {
  section: {
    padding: "100px 20px",
    backgroundColor: "#ffffff",
    fontFamily: "'Inter', sans-serif",
    overflow: "hidden",
  },
  container: {
    maxWidth: "1200px",
    margin: "0 auto",
    display: "flex",
    flexWrap: "wrap", // Crucial for mobile responsiveness
    alignItems: "center",
    gap: "60px",
  },
  contentSide: {
    flex: "1 1 500px", // Grows to fill space, but stacks below 500px
  },
  badge: {
    color: "#9333ea",
    fontWeight: "800",
    fontSize: "24px",
    letterSpacing: "2px",
    textTransform: "uppercase",
    marginBottom: "16px",
    display: "inline-block",
    padding: "4px 12px",
    backgroundColor: "rgba(147, 51, 234, 0.1)",
    borderRadius: "4px",
  },
  heading: {
    fontSize: "clamp(36px, 4vw, 52px)",
    fontWeight: "800",
    color: "#1e293b",
    marginBottom: "20px",
    lineHeight: "1.1",
  },
  accentLine: {
    width: "50px",
    height: "5px",
    backgroundColor: "#9333ea",
    marginBottom: "30px",
    borderRadius: "10px",
  },
  textBlock: {
    display: "flex",
    flexDirection: "column",
    gap: "20px",
  },
  paragraph: {
    fontSize: "18px",
    lineHeight: "1.8",
    color: "#475569",
    margin: 0,
  },
  highlight: {
    color: "#1e3a8a",
    fontWeight: "600",
  },
  imageSide: {
    flex: "1 1 400px",
    display: "flex",
    justifyContent: "center",
    position: "relative",
  },
  imageWrapper: {
    position: "relative",
    width: "100%",
    maxWidth: "450px",
  },
  image: {
    width: "100%",
    height: "550px",
    objectFit: "cover",
    borderRadius: "24px",
    boxShadow: "0 25px 50px -12px rgba(0, 0, 0, 0.15)",
    position: "relative",
    zIndex: 2,
  },
  imageDecor: {
    position: "absolute",
    top: "-20px",
    right: "-20px",
    width: "100%",
    height: "100%",
    border: "2px solid #e2e8f0",
    borderRadius: "24px",
    zIndex: 1,
  },
};

export default About;
